import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import DashboardInternshipTab from "./DashboardInternshipTab";
import DashboardInternshipActiveTab from "./DashboardInternshipActiveTab";
import { getAllStaff, getInternRequestWithFullData,getInternRequestWithFullData2, getSchoolYearB} from "../../api/crud";
import { optionsBranch } from "../../data/branch-data";
import { useDispatch, useSelector } from "react-redux";
import { Container, Grid, Paper } from "@mui/material";
import Select from "react-select";
import MenuItem from "@mui/material/MenuItem";
import { matchOptions } from "../../utils/function";
import { internType } from "../../data/interntype-data";
import { Tooltip, IconButton } from "@mui/material";
import ReactExport from "react-data-export";
import { updateIsLoading } from "../../redux/action/dataAction";
import CardInternship from "./CardInternship";
import { currentYear } from "../../data/config";
import {useMediaQuery} from '@mui/material';
import { is } from "date-fns/locale";
import { padStart, set } from "lodash";
import { Margin, Padding } from "@mui/icons-material";
import CustomSelectChip from '../../Components/CustomSelectChip'; // Adjust the import path as needed


const useScrollPosition = () => {
  useEffect(() => {
    // ดึงตำแหน่งเดิม
    const savedPosition = sessionStorage.getItem('scrollPosition');
    if (savedPosition) {
      window.scrollTo(0, parseInt(savedPosition));
    }

    // บันทึกตำแหน่งใหม่เมื่อ scroll
    const handleScroll = () => {
      sessionStorage.setItem('scrollPosition', window.scrollY.toString());
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
};

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3, pt: 0 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}


export default function DashboardInternshipPage() {
  useScrollPosition();
  const dispatch = useDispatch();
  const profile = useSelector((state) => state.profileReducer.profile);
  const isMobile = useMediaQuery('(max-width:767px)');

  const [value, setValue] = useState(() => {
    const savedTab = sessionStorage.getItem('activeTab');
    return savedTab ? parseInt(savedTab) : 1;
  });

  const [cardActive, setcardActive] = useState("1");
  const [textActive, setTextActive] = useState("ทั้งหมด");
  const [items, setItems] = useState([]);
  const [itemsByBranch, setItemByBranch] = useState([]);
  const [itemsBySupervisorBranch, setItemsBySupervisorBranch] = useState([]);
  const [itemsByBranchFilter, setItemByBranchFilter] = useState([]);
  const [itemsBySupervisorBranchFilter, setItemsBySupervisorBranchFilter] =
    useState([]);
  const [allStaff, setAllStaff] = useState([]);
  const [schoolYear, setSchoolYear] = useState([]);
  const [uniqueCompanyCount, setuniqueCompanyCount] = useState(0);
 

  const [selectedYear, setSelectedYear] = useState(() => {
    const savedYear = sessionStorage.getItem('selectedYear');
    return savedYear || null;
  });


  

  const [optionsNewBranch, setOptionsNewBranch] = useState([
    {
      label: "ทั้งหมด",
      value: 0,
    },
    ...optionsBranch,
  ]);
  const [branchSelected, setBranchSelected] = useState(null);

  const focusItems = value === 0 ? itemsByBranch : itemsBySupervisorBranch;

  // const [focusItems, setFocusItems] = useState([]);

  const onHandleBranchSelect = (data) => {
    setBranchSelected(data);
    sessionStorage.setItem('selectedBranch', JSON.stringify(data));
  };

  const getOptionOwn = (options, profile) => {
    if (profile && profile.set_b_id && profile.b_id !== "0") {
      const setBId = JSON.parse(profile.set_b_id);

      const newOptions = [...options].filter(
        (opt) => setBId.indexOf(opt.value) !== -1
      );

      if (newOptions.length) {
        return newOptions;
      }
    } else if (profile && profile.b_id && profile.b_id !== "0") {
      const newOptions = [...options].filter(
        (opt) => profile.b_id == opt.value
      );

      if (newOptions.length) {
        return newOptions;
      }
    } else if (profile && profile.b_id && profile.b_id == "0") {
      return options;
    }

    return [];
  };
 

  useEffect(() => {
    const options = getOptionOwn([...optionsNewBranch], profile);
    setOptionsNewBranch(options);
  
    if (options.length) {
      // พยายามโหลดค่าที่บันทึกไว้จาก session storage
      const savedBranch = sessionStorage.getItem('selectedBranch');
      if (savedBranch) {
        const parsedBranch = JSON.parse(savedBranch);
        // ตรวจสอบว่าค่าที่บันทึกไว้ยังอยู่ในตัวเลือกที่มีอยู่
        const isValidBranch = options.some(opt => opt.value === parsedBranch.value);
        if (isValidBranch) {
          setBranchSelected(parsedBranch);
          return;
        }
      }
      // ถ้าไม่มีค่าที่บันทึกไว้หรือค่าไม่ถูกต้อง ใช้ค่าเริ่มต้น
      const defaultOptions = options[0];
      setBranchSelected(defaultOptions);
    }
  }, [profile]);

  const getData = async () => {
    dispatch(updateIsLoading(true));

    try {
      const schoolYear = await getSchoolYearB();
      setSchoolYear(schoolYear);
      let resIntern;
      console.log("selectedYear", selectedYear);
      if(selectedYear){ resIntern = await getInternRequestWithFullData2(selectedYear);
      }else{
          resIntern = await getInternRequestWithFullData();
          setSelectedYear(schoolYear.school_yrs);
      }
     

      const resStaff = await getAllStaff();
      //const docsending = await getDocumentRequestByYear(schoolYear);
      const mapStaff = await resStaff.map((staff) => {
        const internOwn =
          resIntern.filter((int) => int.supervisor === staff.id) ?? [];

        return {
          ...staff,
          internOwn,
        };
      });

      setItems(resIntern);
      console.log("resIntern", resIntern);
      
      setAllStaff(mapStaff);
    } catch (err) {
      console.warn(err);
    } finally {
      dispatch(updateIsLoading(false));
    }
  };

  
  const handleYearChange = (data) => {
    const schoolYear = {
      school_yrs: data.value,
    };
    setSelectedYear(schoolYear.school_yrs);
    sessionStorage.setItem('selectedYear', schoolYear.school_yrs.toString());
  };

  const schoolYearsOptions = [
    {value: schoolYear.school_yrs, label: schoolYear.school_yrs},
    {value: schoolYear.school_yrs - 1, label: schoolYear.school_yrs - 1},
    {value: schoolYear.school_yrs - 2, label: schoolYear.school_yrs - 2},
    {value: schoolYear.school_yrs - 3, label: schoolYear.school_yrs - 3},
  
  ]


  const onHandleItemsByBranch = (items, branchSelected) => {
    const studentByBranch = items.filter((student) => {
      if (branchSelected.value == 0) {
        return student;
      } else {
        return student.internStudent?.b_id == branchSelected.value;
      }
    });

    const rows = studentByBranch.filter(
      (item) => +item.st_id && item?.internStudent?.status_id == "31" && item?.status !=0
    );

    const sortData = rows.sort((a, b) => (a.st_id > b.st_id ? 1 : -1));

    return sortData;
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    getData();
   
    
  }, [selectedYear]);

  
 useEffect(() => {
  if (!items.length || !branchSelected || !profile) {
    setItemByBranch([]);
    setItemByBranchFilter([]);
    setItemsBySupervisorBranch([]);
    setItemsBySupervisorBranchFilter([]);
    setValue(0);
    //reset table
    
  } else {
    const itemsB = onHandleItemsByBranch(items, branchSelected);
    
    setItemByBranch(itemsB);
    setItemByBranchFilter(itemsB);

    const itemsBySupervisor = itemsB.filter(
      (item) => item.supervisor === profile.id
    );

    setItemsBySupervisorBranch(itemsBySupervisor);
    setItemsBySupervisorBranchFilter(itemsBySupervisor);

    // เช็คเฉพาะตอนโหลดหน้าครั้งแรก หรือเปลี่ยนฟิลเตอร์
    if (!itemsBySupervisor.length) {
      setValue(0);
    } else {
      setValue(1);
    }
  }
}, [branchSelected, items, profile, selectedYear]);

  useEffect(() => {
    sessionStorage.setItem('activeTab', value.toString());
  }, [value]);



  return (
    <Box>
      <Container fullWidth>
        <Grid container spacing={2}>


          <Grid item xs={6} md={8}>
            <Box
              display="flex"
              justifyContent="flex-start"
              width="100%"
              sx={{ gap: "10px", alignItems: "center" }}
            >
              
          {!isMobile && (  
              <>
            <Typography variant={isMobile ? "h6" : "h5"} sx={{ fontWeight: 'bold' }}>
                  {isMobile ? (
                    <>
                      นิสิตฝึกงาน/สหกิจศึกษา
                    </>
                  ) : (
                    <>
                      สรุปสถานะนิสิตฝึกงาน/สหกิจศึกษา</>
                  )}
                </Typography>

              </>
            )}
            
            

              <Typography variant={isMobile ? "h6" : "h5"} sx={{
                fontWeight: 'bold'

              }}>ปีการศึกษา</Typography>
          



              <Box sx={{
                marginLeft: "10px", fontSize: "18px", fontWeight: "bold", display: "flex", alignItems: "center", gap: "10px",

              }}>
                <Select
                  variant="outlined"
                  options={schoolYearsOptions}
                  value={schoolYearsOptions.find((item) => item.value == selectedYear)}
                  onChange={handleYearChange}
                  sx={{
                    '.MuiOutlinedInput-notchedOutline': {
                      border: '2px solid #4080ea', // Modern border color
                      borderRadius: '8px', // Rounded corners
                      boxShadow: '0 2px 0px rgba(0, 0, 0, 0.1)', // Subtle shadow for depth
                    },
                    '.MuiSelect-select': {
                      display: 'flex',
                      alignItems: 'center',
                      backgroundColor: '#4080ea',
                      color: 'white',
                      borderRadius: '16px',
                      padding: '4px 12px',
                      fontSize: '14px',
                      fontWeight: 'bold',
                    },

                  }}
                />
              </Box>

              

            </Box>
          </Grid>

          <Grid item xs={6} md={4}>
            <Box display="flex" justifyContent="flex-end" width="100%"
            sx={{ gap: "10px", alignItems: "center", }}>  
              
              <Select
                options={optionsNewBranch}
                value={branchSelected}
                onChange={onHandleBranchSelect}
              />
            </Box>
          </Grid>



          <Grid item xs={12}>
            <Box sx={{ gap: "10px", alignItems: isMobile ? "center" : "start", }}>

              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "start",
                  gap: "10px",
                }}
              >
                <CardInternship
                  id="1"
                  label="ทั้งหมด"
                  setTextActive={setTextActive}
                  setcardActive={setcardActive}
                  cardActive={cardActive}
                  value={focusItems.length}
                  callbackFn={() => {
                    setItemByBranchFilter(itemsByBranch);
                    setItemsBySupervisorBranchFilter(itemsBySupervisorBranch);
                  }}
                />

                <CardInternship
                  id="7"
                  label="สถานประกอบการ"
                  setTextActive={setTextActive}
                  setcardActive={setcardActive}
                  cardActive={cardActive}
                  value={new Set(focusItems.map(item => item.company.id)).size
                  }
                />


                <CardInternship
                  id="2"
                  label="นิสิตฝึกงาน (2 เดือน)"
                  setTextActive={setTextActive}
                  setcardActive={setcardActive}
                  cardActive={cardActive}
                  value={
                    focusItems.filter((item) => item.type_internship == "1")
                      .length
                  }
                  callbackFn={() => {
                    const filterList1 = itemsByBranch.filter(
                      (item) => item.type_internship == "1"
                    );

                    const filterList2 = itemsBySupervisorBranch.filter(
                      (item) => item.type_internship == "1"
                    );

                    setItemByBranchFilter(filterList1);
                    setItemsBySupervisorBranchFilter(filterList2);
                   
                  }}
                />
                <CardInternship
                  id="3"
                  label="นิสิตสหกิจศึกษา"
                  setTextActive={setTextActive}
                  setcardActive={setcardActive}
                  cardActive={cardActive}
                  value={
                    focusItems.filter(
                      (item) =>
                        item.type_internship == "2" ||
                        item.type_internship == "3"
                    ).length
                  }
                  callbackFn={() => {
                    const filterList1 = itemsByBranch.filter(
                      (item) =>
                        item.type_internship == "2" ||
                        item.type_internship == "3"
                    );

                    const filterList2 = itemsBySupervisorBranch.filter(
                      (item) =>
                        item.type_internship == "2" ||
                        item.type_internship == "3"
                    );

                    setItemByBranchFilter(filterList1);
                    setItemsBySupervisorBranchFilter(filterList2);
                  }}
                />

                {/* </div>
                  </Box>

                <Box sx={{ gap: "10px", alignItems: isMobile ? "center" : "start", paddingTop: "10px"}}>
                  <div style={{
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "start",
                    gap: "10px",
                  }}>
                  */}

  
                {focusItems.filter((item) => !item.supervisor).length != 0 && (
                  <CardInternship
                    id="4"
                    label="ยังไม่ถูกเลือกนิเทศ"
                    setTextActive={setTextActive}
                    setcardActive={setcardActive}
                    cardActive={cardActive}
                    value={focusItems.filter((item) => !item.supervisor).length}
                    callbackFn={() => {
                      const filterList1 = itemsByBranch.filter(
                        (item) => !item.supervisor
                      );

                      const filterList2 = itemsBySupervisorBranch.filter(
                        (item) => !item.supervisor
                      );

                      setItemByBranchFilter(filterList1);
                      setItemsBySupervisorBranchFilter(filterList2);
                    }}
                  />
                )}

                {profile?.role == 0 && (
                  <CardInternship
                    id="5"
                    label="รอแจ้งที่ตั้ง"
                    setTextActive={setTextActive}
                    setcardActive={setcardActive}
                    cardActive={cardActive}
                    value={
                      focusItems.filter((item) => !item.internLocation).length
                    }
                    callbackFn={() => {
                      const filterList1 = itemsByBranch.filter(
                        (item) => !item.internLocation
                      );

                      const filterList2 = itemsBySupervisorBranch.filter(
                        (item) => !item.internLocation
                      );

                      setItemByBranchFilter(filterList1);
                      setItemsBySupervisorBranchFilter(filterList2);
                    }}
                  />
                )}

                {profile?.role == 0 && (
                  <CardInternship
                    id="6"
                    label="รอส่ง Logbook"
                    setTextActive={setTextActive}
                    setcardActive={setcardActive}
                    cardActive={cardActive}
                    value={
                      focusItems.filter((item) => item.doclogbook.length == 0)
                        .length
                    }
                    callbackFn={() => {
                      const filterList1 = itemsByBranch.filter(
                        (item) => item.doclogbook.length == 0
                      );

                      const filterList2 = itemsBySupervisorBranch.filter(
                        (item) => item.doclogbook.length == 0
                      );

                      setItemByBranchFilter(filterList1);
                      setItemsBySupervisorBranchFilter(filterList2);

                    }}
                  />
                )}

                
              </div>
            </Box>
          </Grid>

         
          <Grid item xs={12}>
          <Paper>     
            <Tabs sx={{ borderBlock : '1px solid',borderColor: 'divider', px: 2 }}
            value={value} onChange={handleChange}>
                <Tab
                  label={`ทั้งหมด (${itemsByBranchFilter.length ?? 0})`}
                  {...a11yProps(0)}
                />
                <Tab
                  label={`นิสิตที่เลือกนิเทศ (${itemsBySupervisorBranchFilter.length ?? 0
                    })`}
                  {...a11yProps(1)}
                />
              </Tabs>

            
              <TabPanel value={value} index={0}>
                <DashboardInternshipTab
                  key={`table-${itemsByBranchFilter.length}`} // เพิ่ม key ที่จะเปลี่ยนเมื่อข้อมูลเปลี่ยน
                  textActive={textActive}
                  items={itemsByBranchFilter}
                  allStaff={allStaff}
                  setValue={setValue}  // เปลี่ยนจาก onUpdateValue เป็น setValue
                  value={value}
                  onRefreshData={getData}


                />
              </TabPanel>

              <TabPanel value={value} index={1}>
                <DashboardInternshipActiveTab
                    key={`table-active-${itemsBySupervisorBranchFilter.length}`} // เพิ่ม key ที่จะเปลี่ยนเมื่อข้อมูลเปลี่ยน
                  items={itemsBySupervisorBranchFilter}
                  allStaff={allStaff}
                  profile={profile}
                  textActive={textActive}
                  setValue={setValue}  // เปลี่ยนจาก onUpdateValue เป็น setValue
                  value={value}
                  onRefreshData={getData}

                />
              </TabPanel>
            </Paper>
          </Grid>

        </Grid>

      </Container>


    </Box>
  );
}
